import nprogress from 'nprogress';

export default {
	/**
	 * Event to trigger before route is processed.
	 * @param {object} context The context to be accessed. Has `to`, `from`, and `next` keys.
	 * @returns {mixed} The next context must be returned.
	 */
	before: ({ to, next }) => {
		if (to.name) {
			nprogress.start();
		}

		next();
	},

	/**
	 * Event to trigger after route is processed.
	 * @param {object} context The context to be accessed. Has `to` and `from` keys.
	 * @returns {void}
	 */
	after: ({ to }) => {
		if (to.meta.static !== false) {
			nprogress.done();
		}
	}
};
